import { useEffect, useState } from "react";
import { Search as SearchIcon, X } from "lucide-react";
import { api } from "@/lib/api";
import Header from "@/components/Header";
import AppRow from "@/components/AppRow";

export default function SearchView() {
  const [q, setQ] = useState("");
  const [apps, setApps] = useState([]);

  useEffect(() => {
    const t = setTimeout(() => {
      api.apps(q ? { search: q } : {}).then(setApps).catch(() => setApps([]));
    }, 200);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="pb-28">
      <Header title="Поиск" subtitle="Найдите приложение по названию" />
      <div className="px-4 pt-4">
        <div className="flex items-center gap-2 px-4 py-3 rounded-2xl bg-white/5 border border-white/10">
          <SearchIcon size={18} className="text-slate-400" />
          <input
            data-testid="search-field"
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Название приложения"
            className="flex-1 bg-transparent outline-none text-sm placeholder:text-slate-500"
          />
          {q && (
            <button data-testid="search-clear" onClick={() => setQ("")} className="text-slate-400">
              <X size={18} />
            </button>
          )}
        </div>

        <div className="mt-4 divide-y divide-white/5">
          {apps.length === 0 ? (
            <div className="py-10 text-center text-slate-500">Ничего не найдено.</div>
          ) : (
            apps.map((app, i) => <AppRow key={app.id} app={app} index={i} />)
          )}
        </div>
      </div>
    </div>
  );
}
